import { render, staticRenderFns } from "./PersonSelectedForm.vue?vue&type=template&id=2066ce9e&"
import script from "./PersonSelectedForm.vue?vue&type=script&lang=js&"
export * from "./PersonSelectedForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2066ce9e')) {
      api.createRecord('2066ce9e', component.options)
    } else {
      api.reload('2066ce9e', component.options)
    }
    module.hot.accept("./PersonSelectedForm.vue?vue&type=template&id=2066ce9e&", function () {
      api.rerender('2066ce9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/ActivityManage/modules/PersonSelectedForm.vue"
export default component.exports